/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/linkedin': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g transform="translate(2 2)" _fill="#8300BF" fill-rule="nonzero"><path pid="0" d="M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14c-.023 7.723-6.277 13.977-14 14zm0-26C7.373 2 2 7.373 2 14s5.373 12 12 12 12-5.373 12-12c-.02-6.62-5.38-11.98-12-12z"/><path pid="1" d="M16.497 10.811a3.738 3.738 0 013.765 3.765v4.379h-2.539v-4.379a1.226 1.226 0 00-2.452 0v4.379h-2.54v-4.379a3.738 3.738 0 013.766-3.765zM7.652 11.424h2.54v7.531h-2.54z"/><circle pid="2" cx="8.966" cy="8.271" r="1.226"/></g>'
  }
})
